<template>
  <div 
    v-if="point"
    class="dish-orders"
  >
  <v-layout wrap justify-end>
    <v-flex xs12>
      <v-layout wrap justify-center style="width:200px;float:right;">
    <v-flex xs2>
      <center>
        <v-icon @click="numItems > 1 ? numItems-- : null">mdi-minus</v-icon>
      </center>
    </v-flex>
    <v-flex xs2>
      <center class="numItems">
        {{ numItems }}
      </center>
    </v-flex>
    <v-flex xs2>
      <center>
        <v-icon @click="numItems++">mdi-plus</v-icon>
      </center>
    </v-flex>
    <v-flex xs6>
      <center>
      <v-btn
        small
        @click="handleOrder"
        :color="config.BGColor"
        :style="{ color: config.Color }"
      >
        {{ $t('dtouch.dishOrders.order', locale) }}
      </v-btn>
      </center>
    </v-flex>
  </v-layout>
    </v-flex>
  </v-layout>
    <v-snackbar
      v-model="showSnackbar"
      :timeout="timeout"
    >
      <p v-if="title">
        {{ title }}
      </p>
      <p v-if="subtitle">
        <small>
          {{ subtitle }}
        </small>
      </p>

      <template v-slot:action="{ attrs }">
        <v-btn
          color="blue"
          text
          v-bind="attrs"
          @click="showSnackbar = false"
        >
          {{ $t('dtouch.dishOrders.close', locale) }}
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
import apiDishOrders from '@/services/apiDishOrders'
export default {
  props: {
    locale: {
      type: String,
      required: true,
    },
    content: {
      type: Object,
      required: true,
    },
    point: {
      type: String,
      required: true,
    },
    config: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    numItems: 1,
    showSnackbar: false,
    timeout: 5000,

    title: null,
    subtitle: null,
  }),
  computed: {
    workspaceID () {
      return this.$store.state.app.dtouchWorkspace
    },
  },
  methods: {
    handleOrder () {
      if (!this.point || !this.workspaceID) alert('error')

      const body = {
        NumItems: this.numItems,
        WorkspaceID: this.workspaceID,
        PointID: this.point,
        MenuContentID: this.content.MenuContentID || this.content.ID,
      }
      apiDishOrders.addOrder(body) 
        .then((response) => {
          if (!response || !response.data || response.data.status !== 'OK') return alert(response ? response.data.error : 'error')
          this.title = this.$t('dtouch.dishOrders.messages.orderAdded', this.locale)
          this.subtitle = this.$t('dtouch.dishOrders.messages.rememberConfirmOrder', this.locale)
          this.showSnackbar = true

          this.$store.state.app.dtouchDishOrder = {
            OrderID: response.data.ID,
            LMD: new Date()
          }
          apiDishOrders.setOrderSession(response.data.ID)
        })
    },
  },
}
</script>
<style scoped>
.dish-orders {
  width: 100%;
  padding: 10px;
}
.numItems {
  border: 1px solid black;
  border-radius: 5px;
  background-color: white;
}
</style>

